import { Navigate, lazyRouteComponent } from 'src/lib/routing';

import { ErrorBoundaryPssTable } from 'components/ErrorBoundaryPssTable/ErrorBoundaryPssTable';

import type { RouteObject } from 'src/lib/routing';

const BookingContainer = lazyRouteComponent(() => import('./BookingContainer'), 'BookingContainer');

const BookingCalendarContainer = lazyRouteComponent(() => import('./containers/BookingCalendarContainer'));
const BookingMessagesContainer = lazyRouteComponent(
  () => import('./containers/BookingMessagesContainer/BookingMessagesContainer'),
);
const BookingSettingsContainer = lazyRouteComponent(() => import('./containers/BookingSettingsContainer'));

const BookingParticipantsContainer = lazyRouteComponent(
  () => import('./containers/BookingParticipantsContainer/BookingParticipantsContainer'),
);
const BookingParticipantsTableContainer = lazyRouteComponent(
  () => import('./containers/BookingParticipantsContainer/BookingParticipantTableContainer'),
);

export const bookingRoutes: RouteObject[] = [
  {
    path: 'bookings/:bookingId',
    element: (
      <ErrorBoundaryPssTable location="BookingContainer">
        <BookingContainer />
      </ErrorBoundaryPssTable>
    ),
    children: [
      {
        path: 'participants',
        element: <BookingParticipantsContainer />,
        children: [
          {
            path: ':segmentId',
            element: <BookingParticipantsTableContainer />,
          },
          { index: true, element: <Navigate to="all" replace /> },
        ],
      },
      {
        path: 'messages',
        element: <BookingMessagesContainer />,
      },
      {
        path: 'calendar',
        element: <BookingCalendarContainer />,
      },
      {
        path: 'settings',
        element: <BookingSettingsContainer />,
      },
      {
        index: true,
        element: <Navigate to="participants/all" replace />,
      },
    ],
  },
];
